import styled, { css } from 'styled-components'

const Main = styled.main`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: ${theme.spacing(5)} ${theme.spacing(10)};

    h1 {
      font-size: 7.2rem;
      margin-bottom: 0;
    }

    p {
      font-size: 2.4rem;
      margin-bottom: ${theme.spacing(10)};
    }
  `}
`

export default {
  Main,
}
